import React from "react";
import { Modal } from "antd";
import { notify } from "@/shared/utils/notify";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { rulesSushiLunchService } from "../../../shared/services";
import { TableProperties } from "../../../shared/components/ui/Table/types";

const { confirm } = Modal;

export const useRemoveRulesSushiLunch = () => {
  const [tableProps, setTableProps] = React.useState<TableProperties>();

  const showDeleteConfirm = (id: number, name: string) => {
    confirm({
      title: `¿Estás seguro de eliminar esta regla ${name}?`,
      icon: <ExclamationCircleOutlined />,
      content: "Esta acción no se puede deshacer",
      okText: "Si",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        try {
          await rulesSushiLunchService.remove(id);
          notify.success(`Regla ${name} eliminada con éxito`);
          tableProps?.refresh();
        } catch (error: any) {
          notify.error(error.message);
        }
      },
      onCancel() {
        notify.info("Operación cancelada");
      },
    });
  };

  return {
    showDeleteConfirm,
    setTableProps,
  };
};
